import { render, staticRenderFns } from "./FatturaStock.vue?vue&type=template&id=8d08e838"
import script from "./FatturaStock.vue?vue&type=script&lang=js"
export * from "./FatturaStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports